import React from 'react';
import { getDisplayLabelStyles } from '../utils';
import classNames from 'classnames';
import { useGetChevronComponent } from '../../CardFrameCollection/components/CarouselIndicator';
import { getTitleWithoutTags } from 'src/utils/getStringFromHtmlTag';
import style from '../ListPresentation.module.scss'
import { InfiniteAutoScroller } from '../../NewAnnouncementBar/Components/InfiniteAutoScroller';
import { useListPresentationContextData } from '../context/ListPresentationContext';

export function ListDescriptionSection({onNextArrowClick, onPrevArrowClick}) {
  const data = useListPresentationContextData();
  const { isMobile, listPresentationConfig, contentTypeConditions } = data.state;
  const { getConfigsAndUtils } = data.utilities;
  const {
    sectionColors,
    showArrow,
    carouselConfigs,
    featuredReelConfigs,
    carouselIndicatorConfigs,
    isMoveableHeading,
    // containerHorizontalPadding,
    isLayoutCarousel,
    instaHandleProps
  } = getConfigsAndUtils().generalValues;
  const {showInstaHandle = false, instaHandle = '', instaHandlePosition = ''} = instaHandleProps || {}
  const isLogoSliderCarousel =
    listPresentationConfig?.layoutType === 'carousel' && contentTypeConditions.logoSlider;
  const isFocusedReelExpandOnMobile = featuredReelConfigs.expandFocusedReel;

  const alwaysShowInLeft = isMoveableHeading && carouselConfigs?.arrowPosition === 'top';
  const displayLabelStyles = getDisplayLabelStyles(listPresentationConfig, alwaysShowInLeft);

  const { LeftArrow, RightArrow } = useGetChevronComponent({
    type: carouselConfigs?.arrowShape,
    onNextArrowClick,
    onPrevArrowClick,
    isMobile,
    scrollPercentage: carouselIndicatorConfigs.scrollPercentage,
    colorConfig: {
      arrowColor: carouselConfigs?.arrowColor,
      shapeColor: carouselConfigs?.shapeColor,
    },
  });
  const headingText = getTitleWithoutTags(listPresentationConfig?.heading);
  const descriptionText = getTitleWithoutTags(listPresentationConfig?.description);
  const isEmptyText = !(headingText || descriptionText);

  const isTextCenter = listPresentationConfig.textAlign === 'center';
  // const updatedHtmlForMoveableText = `<div style="display: flex; align-items: center; gap: 28px;"> <div style="height: 10px; width: 10px; border-radius: 50%; background: #111C36; opacity: .3;"></div> <div style = "font-weight: 400;">${listPresentationConfig?.heading} </div></div>`

  function handleInstaClick() {
    window.open(`https://instagram.com/${instaHandle}`, '_blank');
  }

  const showInstaUserName = () => (
    (instaHandle && <div onClick={handleInstaClick} className='tw-mt-[8px] hover:tw-underline tw-leading-[1.4] tw-cursor-pointer [&>*]:tw-m-0 [&>*]:tw-text-inherit tw-text-[14px] tw-font-normal tw-text-[#111C36B2]'
      style={{ textAlign: listPresentationConfig?.textAlign === 'center' ? 'center' : 'left', }}
    >
      {`@${instaHandle}`}
    </div>)
  )

  const renderMoveableHeadingContent = () => (
    <div className='tw-flex tw-items-center tw-gap-[28px] tw-mt-[26px]'>
      <div className='tw-h-[10px] tw-w-[10px] tw-rounded-[50%] tw-bg-newBlack tw-opacity-30'></div>
      <div
        className={`tw-m-0 tw-mb-[4px] [&>*]:tw-m-0 [&>*]:tw-font-normal [&>*]:tw-text-inherit tw-w-max ${isTextCenter ? 'tw-text-center' : ''} ${style.group}`}
        style={{ color: sectionColors?.text }}
        dangerouslySetInnerHTML={{ __html: listPresentationConfig?.heading }}
      />
    </div>
  )
  const renderMoveableHeading = () => (
      <InfiniteAutoScroller
        gap={28}
        scrollSpeedInSec={4}
        totalItems={4}
        wrapperClasses="!tw-flex-none"
        customClasses = {'!tw-m-0'}
        maxWidth = {isMoveableHeading && carouselConfigs?.arrowPosition === 'top' && isLayoutCarousel && !isMobile ? '90%' : '100%'}
      >
        {renderMoveableHeadingContent()}
        {renderMoveableHeadingContent()}
        {renderMoveableHeadingContent()}
        {renderMoveableHeadingContent()}

      </InfiniteAutoScroller>
  )

  return !isEmptyText && (
    <div
      className={classNames(
        'tw-relative tw-mx-auto tw-flex tw-flex-col',
        (!isEmptyText || showArrow) ? isMobile
          ? !isLogoSliderCarousel
            ? isFocusedReelExpandOnMobile
              ? 'tw-mb-[36px]'
              : 'tw-mb-[24px]'
            : ''
          : isLogoSliderCarousel
            ? 'tw-mb-[1px]'
            : 'tw-mb-[36px]' : '',
        listPresentationConfig?.descriptionPosition === 'top' ? 'tw-flex-col-reverse' : ''
      )}
      style={{
        ...displayLabelStyles,
        // padding: (isMoveableHeading) ? 0 : !isLayoutCarousel ?  `0px ${containerHorizontalPadding}px` : '',
      }}
    >
      <div className="tw-flex tw-w-[100%] tw-flex-col" style={displayLabelStyles}>
        {isMoveableHeading && renderMoveableHeading()}
        {!isMoveableHeading &&
          <div
            className={`tw-m-0 tw-mb-[4px] [&>*]:tw-m-0 [&>*]:tw-font-normal [&>*]:tw-text-inherit ${isTextCenter ? 'tw-text-center' : ''}`}
            style={{
              color: sectionColors?.text,
            }}
            dangerouslySetInnerHTML={{
              __html: listPresentationConfig?.heading
            }}
          />
        }
        {!isMobile && showArrow && carouselConfigs?.arrowPosition === 'top' && (
          <div className="tw-absolute tw-right-0 tw-top-[50%] tw-flex tw-translate-y-[calc(-50%_-_2px)] tw-gap-[8px]">
            <LeftArrow />
            <RightArrow />
          </div>
        )}
      </div>
      <div
        style={{
          justifyContent: showInstaHandle ? listPresentationConfig?.textAlign === 'center' ? 'center' : 'left' : '',
        }}
        className={`tw-w-[100%] ${(showInstaHandle) ? !isMobile ? 'tw-flex tw-items-center' : 'tw-flex tw-flex-col' : ''}`}>
        {descriptionText && <div
          className="tw-m-0 tw-mt-[8px] tw-leading-[1.4] [&>*]:tw-m-0 [&>*]:tw-text-inherit tw-mr-[8px]"
          style={{
            color: '#808080',
            textAlign: listPresentationConfig?.textAlign === 'center' ? 'center' : 'left',
          }}
          dangerouslySetInnerHTML={{
            __html: listPresentationConfig?.description,
          }}
        />}
        {
          (showInstaHandle && instaHandlePosition === 'description') && showInstaUserName()
        }
      </div>
    </div>
  );
}
